/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     Dialog.js
//   Details:    Dialog.js
//
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// WI3713 30/01/24 JC  M01JC	Cancel now optional
//-------------------------------------------------------
*/

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './css/Dialog.css';

class Dialog extends Component {
	constructor(props) {
		super(props);

		this.handleConfirm = this.handleConfirm.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
	}

	handleConfirm = event => {
		event.preventDefault();
		if (typeof this.props.onConfirm === "function") {
			this.props.onConfirm();
		}
	}

	handleCancel = event => {
		event.preventDefault();
		if (typeof this.props.onCancel === "function") {
			this.props.onCancel();
		}
	}

	render() {
		const { title, message, confirmClass, confirmText, hideCancel } = this.props; //M01JC

		return (
			<div className="dialog-overlay">
				<div className="dialog-body">
					<h4>{title}</h4>
					<p>{message}</p>
					<div className="button-tray bottom">
						<button type="button" className={`btn ${confirmClass}`} onClick={this.handleConfirm}>{confirmText}</button>
						{!hideCancel? //M01JC allow cancel to be hidden
							<button type="button" className="btn btn-default" onClick={this.handleCancel}>Cancel</button>
							: []}
					</div>
				</div>
			</div>
		);
	}
}

Dialog.propTypes = {
	title: PropTypes.string.isRequired,
	message: PropTypes.string.isRequired,
	confirmClass: PropTypes.string.isRequired,
	confirmText: PropTypes.string.isRequired,
	onConfirm: PropTypes.func.isRequired,
	onCancel: PropTypes.func,
	hideCancel: PropTypes.bool
};


export default connect()(Dialog);
